import { Container } from '@mui/material';
import Page from 'src/shared/components/Page';
import useSettings from 'src/shared/hooks/useSettings';
import TermsAndConditions from './section/TermsAndConditions';

export default function TermsAndConditionPage() {
  const { themeStretch } = useSettings();

  return (
    <Page title="Terms and Condition">
      <Container
        maxWidth={themeStretch ? false : 'lg'}
        sx={{
          marginTop: '100px',
          marginBottom: '100px',
          display: 'grid',
          gap: 3,
        }}
      >
        <TermsAndConditions />
      </Container>
    </Page>
  );
}
